<template>
  <v-footer fixed dark color="primary text-center" padless>
      <v-divider></v-divider>

      <v-card-text class="white--text">
        Copyright &copy; {{ new Date().getFullYear() }} —
        <strong>transformPNR</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
};
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: white !important;
}
</style>